import { useEffect, useState, VoidFunctionComponent } from 'react';
import { ThreeEvent } from '@react-three/fiber';
import { useMask, useTexture } from '@react-three/drei';
import { useResponsive } from '@/hooks/useResponsive';
import { offblack } from '@/lib/colors';

interface Props {
    src: string;
    onClick: () => void;
    aspect: number;
    scale: number;
}
export const EditionIcon: VoidFunctionComponent<Props> = ({ src, onClick, aspect = 1, scale = 1 }) => {
    const invertStencil = useMask(1, true);
    const [hovered, setHovered] = useState<boolean>(false);
    const { responsiveValue } = useResponsive();
    const iconScale = responsiveValue(0.13, 0.18);
    const texture = useTexture(src);

    const over = (e: ThreeEvent<PointerEvent>): void => {
        e.stopPropagation();
        setHovered(true);
    };
    const out = (): void => {
        setHovered(false);
    };
    useEffect(() => {
        if (hovered) {
            document.body.style.cursor = 'pointer';
        }
        return () => {
            document.body.style.cursor = 'auto';
        };
    }, [hovered]);
    return (
        <mesh onClick={onClick} onPointerOver={over} onPointerOut={out}>
            <planeGeometry attach="geometry" args={[iconScale * aspect * scale, iconScale * scale]} />
            <meshBasicMaterial color={offblack} map={texture} transparent {...invertStencil} />
        </mesh>
    );
};
